import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class ScheduleServiceService {
  constructor(private http: HttpClient) { }

  getDoctorsAndEvents() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/ScheduledPatient/getAllEventsAndDoctors');
  }

  getPatientInfo(patientId,scheduleId){
    return this.http.get(globalAdd.Paneladdress + 'api/Ha/ScheduledPatient/getPatientInfo?patientId='+ patientId+'&scheduleId='+ scheduleId);
  }

}
